import { createRouter, createWebHistory } from "vue-router";
import store from "../store";

const routes = [
  {
    path: "/",
    name: "home",
    component: () => import("../views/Home.vue"),
  },
  {
    path: "/rent",
    name: "rent",
    beforeEnter: (to, from, next) => {
      if (store.getters.autoForwardSingleLocation && store.state.pointSells.length === 1) {
        const pointSell = store.state.pointSells[0];
        store.commit("doSetPointSell", pointSell);
        next({
          name: "rent-search-category",
          params: { pointSellMssId: pointSell.mssId, categoryIndex: 0 },
          query: to.query
        });
      } else {
        next();
      }
    },
    component: () => import("../views/Rent.vue"),
  },
  {
    path: "/rent/search/:pointSellMssId",
    name: "rent-search",
    component: () => import("../views/RentSearch.vue"),
  },
  {
    path: "/rent/search/:pointSellMssId/:categoryIndex",
    name: "rent-search-category",
    component: () => import("../views/RentSearch.vue"),
  },
  {
    path: "/rent/booking/:pointSellMssId/:productMssId",
    name: "rent-booking",
    component: () => import("../views/RentBookingWrapper.vue"),
  },
  {
    path: "/rent/booking-packet/:pointSellMssId/:productMssId",
    name: "rent-booking-packet",
    component: () => import("../views/RentBookingWrapper.vue"),
  },
  {
    path: "/course",
    name: "course",
    beforeEnter: (to, from, next) => {
      if (store.getters.autoForwardSingleLocation && store.state.locations.length === 1) {
        const location = store.state.locations[0];
        store.commit("doSetLocation", location);
        next({
          name: "course-search-by-location-category",
          params: { locationMssId: location.mssId, categoryMssId: 0 },
          query: to.query
        });
      } else {
        next();
      }
    },
    component: () => import("../views/Course.vue"),
  },
  {
    path: "/course/search/:locationMssId",
    name: "course-search",
    component: () => import("../views/CourseSearch.vue"),
  },
  {
    path: "/course/search/:locationMssId/:categoryIndex",
    name: "course-search-category-forward",
    component: () => import("../views/CourseSearchForward.vue"),
  },
  {
    path: "/course/search/l/:locationMssId/c/:categoryMssId",
    name: "course-search-by-location-category",
    component: () => import("../views/CourseSearch.vue"),
  },
  {
    path: "/course/booking/private/:locationMssId/:productMssId",
    name: "course-private-booking",
    component: () => import("../views/CoursePrivateBookingWrapper.vue"),
  },
  {
    path: "/course/booking/group/:locationMssId/:productMssId",
    name: "course-group-booking",
    component: () => import("../views/CourseGroupBooking.vue"),
  },
  {
    path: "/course/booking/camp/:locationMssId/:productMssId/:groupCourseMssId",
    name: "course-camp-booking",
    component: () => import("../views/CourseCampBooking.vue"),
  },
  {
    path: "/cart",
    name: "cart",
    component: () => import("../views/Cart.vue"),
  },
  {
    path: "/checkout-pickup",
    name: "checkout-pickup",
    component: () => import("../views/CheckoutPickUp.vue"),
  },
  {
    path: "/checkout-contacts",
    name: "checkout-contacts",
    component: () => import("../views/CheckoutContacts.vue"),
  },
  {
    path: "/checkout-payment/:paymentId",
    name: "checkout-payment",
    component: () => import("../views/CheckoutPayment.vue"),
  },
  {
    path: "/checkout-payment-result/:id/:refId",
    name: "checkout-payment-result",
    component: () => import("../views/CheckoutPaymentResult.vue"),
  },
  {
    path: "/checkout-completed/:orderrId",
    name: "checkout-completed",
    component: () => import("../views/CheckoutCompleted.vue"),
  },
  {
    path: "/checkout-completed/:orderrId/:transId",
    name: "checkout-completed-transid",
    component: () => import("../views/CheckoutCompleted.vue"),
  },
  {
    path: "/static-content/:staticContentId/",
    name: "static-content",
    component: () => import("../views/StaticContent.vue"),
  },
  {
    // Living specimen of the theme; not linked from the navigation.
    path: "/styleguide",
    name: "styleguide",
    component: () => import("../views/StyleGuide.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
});

export default router;
